import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders children at `document.body`, escaping any ancestor `overflow`/stacking
 * context. Used by overlays (Dialog, Toast, Tooltip) so they sit in a
 * predictable z-layer. No-op until mounted to stay SSR-safe.
 */
export function Portal({ children }: { children: ReactNode }): React.ReactPortal | null {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  if (!mounted) return null;
  return createPortal(children, document.body);
}
